import { Helmet } from "react-helmet-async";

const SITE_URL = "https://freelamedia.com";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Freela Media",
  url: SITE_URL,
  logo: "https://freelamedia.com/og-image.jpg",
  description:
    "Agência global de marketing digital, branding, comunicação e publicidade. Resultados mensuráveis para empresas ambiciosas.",
  foundingDate: "2016",
  sameAs: [
    "https://www.instagram.com/freelamedia",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer service",
    availableLanguage: ["Portuguese", "English", "Spanish", "French", "German", "Italian"],
  },
  areaServed: {
    "@type": "Place",
    name: "Worldwide",
  },
  knowsLanguage: ["pt", "en", "es", "fr", "de", "it"],
};

const servicesSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Serviços Freela Media",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      item: {
        "@type": "Service",
        name: "Gestão de Redes Sociais",
        description: "Gestão completa de redes sociais com estratégia, conteúdo e monitoramento.",
        url: `${SITE_URL}/alpha`,
        provider: { "@type": "Organization", name: "Freela Media" },
      },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@type": "Service",
        name: "Tráfego Pago",
        description: "Campanhas de mídia paga em Google Ads, Meta Ads, TikTok Ads e mais.",
        url: `${SITE_URL}/trafego`,
        provider: { "@type": "Organization", name: "Freela Media" },
      },
    },
    {
      "@type": "ListItem",
      position: 3,
      item: {
        "@type": "Service",
        name: "Lançamentos Digitais",
        description: "Estratégias de lançamento digital para infoprodutos e e-commerce.",
        url: `${SITE_URL}/lancamentos`,
        provider: { "@type": "Organization", name: "Freela Media" },
      },
    },
    {
      "@type": "ListItem",
      position: 4,
      item: {
        "@type": "Service",
        name: "Criação de Marcas e Branding",
        description: "Identidade visual, branding estratégico e posicionamento de marca.",
        url: `${SITE_URL}/marcas`,
        provider: { "@type": "Organization", name: "Freela Media" },
      },
    },
    {
      "@type": "ListItem",
      position: 5,
      item: {
        "@type": "Service",
        name: "Gráfica & Impressos",
        description: "Design gráfico profissional e materiais impressos de alta qualidade.",
        url: `${SITE_URL}/grafica`,
        provider: { "@type": "Organization", name: "Freela Media" },
      },
    },
    {
      "@type": "ListItem",
      position: 6,
      item: {
        "@type": "Service",
        name: "Funis de Vendas",
        description: "Construção de funis de vendas automatizados para conversão máxima.",
        url: `${SITE_URL}/funis`,
        provider: { "@type": "Organization", name: "Freela Media" },
      },
    },
    {
      "@type": "ListItem",
      position: 7,
      item: {
        "@type": "Service",
        name: "Estratégia & Posicionamento",
        description: "Consultoria estratégica e posicionamento de mercado para crescimento.",
        url: `${SITE_URL}/estrategia`,
        provider: { "@type": "Organization", name: "Freela Media" },
      },
    },
    {
      "@type": "ListItem",
      position: 8,
      item: {
        "@type": "Service",
        name: "Direct Response Marketing",
        description: "Marketing de resposta direta focado em conversão e ROI mensurável.",
        url: `${SITE_URL}/direct-response`,
        provider: { "@type": "Organization", name: "Freela Media" },
      },
    },
    {
      "@type": "Service",
      name: "Automações & Inteligência Artificial",
      description: "Automação de processos com IA para escalar resultados.",
      url: `${SITE_URL}/ai`,
      provider: { "@type": "Organization", name: "Freela Media" },
    },
  ],
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Freela Media",
  url: SITE_URL,
  inLanguage: ["pt-BR", "en", "es", "fr", "de", "it"],
  publisher: {
    "@type": "Organization",
    name: "Freela Media",
  },
};

interface StructuredDataProps {
  pageSchema?: object;
}

const StructuredData = ({ pageSchema }: StructuredDataProps) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(servicesSchema)}
      </script>
      {pageSchema && (
        <script type="application/ld+json">
          {JSON.stringify(pageSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default StructuredData;
